export default __webpack_public_path__ + "static/media/SmolageIcon.550dfe9b.png";